import React from 'react';
import { type RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const UmrahHajjPage = lazy(() => import('../pages/umrah-hajj/page'));
const DestinationPage = lazy(() => import('../pages/destination/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const BlogArticlePage = lazy(() => import('../pages/blog/article/page'));
const SaudiRelocationPage = lazy(() => import('../pages/saudi-relocation/page'));
const VisitLondonPage = lazy(() => import('../pages/visit-london/page'));
const FlightsPage = lazy(() => import('../pages/flights/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsConditionsPage = lazy(() => import('../pages/terms-conditions/page'));
const CookiePolicyPage = lazy(() => import('../pages/cookie-policy/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/umrah-hajj',
    element: <UmrahHajjPage />,
  },
  {
    path: '/family-holidays-destinations',
    element: <DestinationPage />,
  },
  {
    path: '/destinations',
    element: <DestinationPage />,
  },
  {
    path: '/travel-guides',
    element: <BlogPage />,
  },
  {
    path: '/travel-guides/:slug',
    element: <BlogArticlePage />,
  },
  {
    path: '/saudi-relocation',
    element: <SaudiRelocationPage />,
  },
  {
    path: '/visit-london',
    element: <VisitLondonPage />,
  },
  {
    path: '/air-tickets-deals',
    element: <FlightsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-and-conditions',
    element: <TermsConditionsPage />,
  },
  {
    path: '/cookie-policy',
    element: <CookiePolicyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;